import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Region } from 'src/app/bo/region';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { DrilllogGuiComponent } from '../drilllog-gui/drilllog-gui.component';
import { HoleConditionGuiComponent } from '../hole-condition-gui/hole-condition-gui.component';
import { LithoGuiComponent } from '../litho-gui/litho-gui.component';
import { MineralisationGuiComponent } from '../mineralisation-gui/mineralisation-gui.component';

@Component({
  selector: 'app-geology-gui',
  templateUrl: './geology-gui.component.html',
  styleUrls: ['./geology-gui.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DrilllogGuiComponent,
    HoleConditionGuiComponent,
    LithoGuiComponent,
    MineralisationGuiComponent
  ]
})
export class GeologyGuiComponent{
  currentRegionId = signal<number>(undefined);
  tab = signal(1);
  isAdminOrResReg = signal(false);

  private readonly destroyRef = inject(DestroyRef);


  constructor(
    public utilService: UtilisateurService,
  ) { 
    this.updateRegionId();
    }

  


  protected changerTab(numTab: number) {
    // if(numTab === 1) this.reloadProducts = true;

     this.tab.set(numTab);
   }

   
  private updateRegionId() {
    this.utilService.currentRegionForSetupRegion$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
       next: (region: Region) => {
         this.currentRegionId.set(region.regionId);
       }
     });
 
     if (this.currentRegionId() == undefined)
       this.currentRegionId.set(this.utilService.currentRegionForSetupRegion.regionId);
   }

}
